module.exports = __webpack_public_path__ + "img/break-time.e4cdfb05.png";